<div class="row" *ngIf="totalCount > 0">
  <div class="col-sm-12 col-md-6">
    <div class="d-flex flex-row">
      <span class="p-1 align-self-center">
        Showing <b>{{ recordFrom }}</b> to <b>{{ recordTo }}</b> of <b>{{ totalCount }}</b> rows
      </span>

      <span class="p-1">
        <select class="form-select" [value]="pageSize" (change)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
        </select>
      </span>

      <span class="p-1 align-self-center">rows per page</span>
    </div>
  </div>

  <div class="col-sm-12 col-md-6">
    <div class="float-md-end" *ngIf="totalPages > 1">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <!-- Previous -->
          <li class="page-item" [class.disabled]="currentPage === 1">
            <button class="page-link" (click)="changePage(currentPage - 1)" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>

          <!-- Page Numbers -->
          <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
            <button class="page-link" (click)="changePage(page)">
              {{ page }}
            </button>
          </li>

          <!-- Next -->
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <button class="page-link" (click)="changePage(currentPage + 1)" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
